/*대시보드 영역 내의 이벤트 처리 함수*/
import {getNoData} from "./items/index.js";
import * as constants from "./widgetConstants.js";
import * as DashboardApi from "../../apiCall/dashboard/index.js";
import {drawFrameList, openSettingPopup} from "./components/widget-setting/index.js";
import {checkRefreshTarget, closeWidgetMore, widgetBoard} from "./index.js";
import {WIDGET} from "./widgetConstants.js";
import u from "../../util"
import {deleteDatabase} from "../../indexedDB/index.js";

/*모바일 여부 확인*/
const agentInfo = () => {
    const agent = navigator.userAgent;
    return {
        isIphone: agent.indexOf('iPhone') >= 0 || agent.indexOf('iPad') >= 0,
        isAndroid: agent.indexOf('Android') >= 0,
    };
}

const {isIphone, isAndroid, isTest} = agentInfo();
const isMobile = isIphone || isAndroid || isTest;

const clickPopupArea = (e) => {
    const $eTarget = $(e.target);
    //프로젝트 선택 - 파일/프로젝트/통계 공용
    if ($eTarget.closest(".button-project-change, .button-project-select").length > 0) {
        const widget_user_srno = $eTarget.closest('.widget-project-content, .widget-project-summary, .widget-file-list').attr('id');
        PostPopup.openWritingView('', '', {
            mode: DetailCode.DASHBOARD.CODE,
            selectable: true,
            maxSelection: 1,
            firstEditor: false,
            widget_user_srno,
        });
    }

    //포스트 조회 - 멘션/프로젝트/미확인알림 공용
    if ($eTarget.closest('.js-all-post-item').length > 0) {
        clickAllPostsSearchItems(e);
    }

    //알림모두읽기
    if ($eTarget.closest('.js-alarm-read-all').length > 0) {
        const $target = $eTarget.closest("li");

        const apiKey = WIDGET[$target.attr('data-type')].API.API_KEY;
        const WIDGET_USER_SRNO = $target.attr('id');
        apiKey && deleteDatabase(`${apiKey}_${WIDGET_USER_SRNO}`)
        AlarmUpdate.readAllAlarm()
    }

    //더보기메뉴
    if ($eTarget.closest('.widget-more-button').length > 0
        || $eTarget.closest('.js-widget-more-layer').length > 0) {
        const $target = $eTarget.closest("li");
        const popup = $target.find('.js-widget-more-layer')
        if (popup.is(":visible")) popup.fadeOut(100);
        else popup.fadeIn(100);
    }

    // 위젯삭제
    if ($eTarget.closest(".button-del-widget").length) {
        const $target = $eTarget.closest("li");
        const WIDGET_USER_SRNO = $target.attr('id');
        globalValue.widgetInfo = ''
        DashboardApi.getApi('deleteWidget', ({USER_ID: _USER_ID, WIDGET_USER_SRNO}));

        const apiKey = WIDGET[$target.attr('data-type')].API?.API_KEY;
        apiKey && deleteDatabase(`${apiKey}_${WIDGET_USER_SRNO}`)

        $target.remove();
        if ($('#dashboardWrap > li').length === 0) {
            $('.js-button-widget-add').css('display', '')
        }
    }
    // 위젯크기변경
    if ($eTarget.closest(".widget-changing").length) {
        const $target = $eTarget.closest("li");
        const WIDGET_USER_SRNO = $target.attr('id');
        const isWideNow = $target.attr('wide') !== '';
        const WIDGET_ROW = isWideNow ? "1" : "2"
        DashboardApi.getApi('updateWidgetSize', ({USER_ID: _USER_ID, WIDGET_USER_SRNO, WIDGET_ROW: WIDGET_ROW}));
        $target.attr('wide', isWideNow ? '' : 'widget-wide-item')
        $target.find('.widget-changing').text(isWideNow ? i18next.t(main.fullSizeWidget) : i18next.t(main.halfSizeWidget))
        globalValue.widgetInfo = ''
    }
    if ($eTarget.closest(".js-star-item").length) {
        const $target = $eTarget.closest("li");
        const STAR_SRNO = $target.attr('data-star-srno').split("-")[0];
        OpenUtil.openMessengerByFavoriteGroupCode(STAR_SRNO);
    }
    //더보기
    if ($eTarget.closest(".direct").length > 0) {
        const code = e.target.closest('li[id]').getAttribute("class").split("-")[1];
        const isProject = code === 'project';
        const isFile = code === 'file';
        const COLABO_SRNO = e.target.closest('li[id]').getAttribute("colabo_srno");
        if (isMobile) {
            const jsonData = isProject ? {
                CODE: "PROJECT",
                COLABO_SRNO
            } : {
                CODE: code.toUpperCase(),
            }
            BridgeSend(jsonData);
        } else {
            if(isProject){
                ViewChanger.loadPageJson({
                    code: 'detail',
                    first: COLABO_SRNO
                })
            } else if (isFile) {
                ViewChanger.loadPageJson({
                    code,
                    first: COLABO_SRNO
                })
            }
        }
    }
}

/*우측 프로필 영역에 해당하는 클릭 이벤트 함수*/
const lnbAreaClick = (e) => {
    if ($(e.target).closest('dd').length > 0) {
        const taskId = $(e.target).closest('dd').find('span').attr('id');
        LocalUtil.setLocal("TASK_DASHBOARD", taskId);
        ViewChanger.loadPageJson({code: "task"});
    }
    if ($(e.target).closest(".button-widget-set").length > 0) {
        if (Often.isFunc('NEW_BADGE')) NewBadge.closePopup();
        openSettingPopup();
        drawFrameList();
    } else if ($(e.target).closest(".button-setup").length > 0) {
        MySettings.openPopup({layerCode: "PROJECT"});
    }

}

/*북마크, 프로젝트 최근 게시글, 나를 언급 아이템에 대한 클릭 이벤트 함수*/
const clickAllPostsSearchItems = (e) => {
    const $allPostItem = $(e.target).closest(".js-all-post-item");
    // if (LimitGuest.isSearchLimitGuest("post", $allPostItem.attr("rgsn_dttm"))) return; 제한된 게스트의 경우?

    const COLABO_SRNO = $allPostItem.attr('colabo_srno');
    const COLABO_COMMT_SRNO = $allPostItem.attr('colabo_commt_srno');
    const COLABO_REMARK_SRNO = Often.null2Void($allPostItem.attr("colabo_remark_srno"), "")
    if (u.n2v(COLABO_SRNO, "-1") === "-1") return;

    readProjectItem(COLABO_COMMT_SRNO);
    const jsonData = {
        CODE: "PROJECT_DETAIL",
        COLABO_SRNO,
        COLABO_COMMT_SRNO,
        COLABO_REMARK_SRNO
    };
    BridgeSend(jsonData);
    PostPopup.togglePostView(COLABO_SRNO, COLABO_COMMT_SRNO, COLABO_REMARK_SRNO, function () {
        $allPostItem.addClass("highlight");
    });
}

/*id = dashboardWrap 내의 아임템들을 드래그&드롭으로 이동할 수 있게 처리하는 함수*/
const sortableWidget = () => {
    Mutil.lib.getSortable().then(() => {
        Sortable.create($("#dashboardWrap")[0], {
            swapThreshold: 1,
            animation: 100,
            filter: ".js-style-toolbar",
            onEnd: async (evt) => {
                const stDy = makeSequenceArray(evt.to.children);
                await DashboardApi.getApi('changeSequence', {WIDGET_SEQUENCE_REC: stDy});
                globalValue.widgetInfo = '';
            }
        })
    });
}

/*위젯 이동 후의 리스트를 sequence로 만들어 반환하는 함수*/
const makeSequenceArray = (item) => {
    return Array.from(item).map((v, i) => ({WIDGET_USER_SRNO: v.id, OTPT_SQNC: i + 1, USER_ID: _USER_ID}));
}

/*프로필의 업무 count 데이터를 받아 갱신해주는 함수*/
const taskSummrCount = (dat) => {
    const $taskSummrCount = $('.dashboard-work-num-wrap');

    $taskSummrCount.find('#approachCnt').text(dat.MY_TASK_APPROACH_CNT);
    $taskSummrCount.find('#delayCnt').text(dat.MY_TASK_DELAY_CNT);
    $taskSummrCount.find('#totalCnt').text(dat.MY_TASK_TOTAL_CNT);
}


/*프로젝트 최근 게시글 클릭 시 미확인(빨간 점) 읽음 처리*/
const readProjectItem = (colaboCommtSrno) => {
    if ($(`#allPosts-${colaboCommtSrno}`).length === 0) return;
    $(`#allPosts-${colaboCommtSrno} > span.article-icon-wrap`).each((_, item) => {
        $(item).removeClass('alarm');
    });
}


/*프로젝트 최근 게시글, 업무 리포트, 파일함 위젯마다 projectListView 함수 호출부*/
const projectList = (dat) => {
    if (typeof dat === "undefined") return;
    if (typeof dat.WIDGET_USER_SRNO == 'undefined') return;

    let widget = ''
    switch (dat.WIDGET_SRNO) {
        case WIDGET.PROJECT.SRNO:
            widget = widgetBoard.$state.projectContent.find(v => v.key === dat.WIDGET_USER_SRNO)?.val
            break;
        case WIDGET.REPORT.SRNO:
            widget = widgetBoard.$state.projectSummary.find(v => v.key === dat.WIDGET_USER_SRNO)?.val
            break;
        case WIDGET.FILE.SRNO:
            widget = widgetBoard.$state.file.find(v => v.key === dat.WIDGET_USER_SRNO)?.val
            break;
    }

    if (widget !== '') {
        widget.$props.hasRenderedOnScreen = false;
        widget.setup({
            COLABO_SRNO: dat.COLABO_SRNO,
            isInit: true,
            isDataDrivenRendering: true
        });
    }
}

/*프로젝트 바인딩 처리 함수*/
const putProject = async ({WIDGET_USER_SRNO, PROJECT_SRNO: COLABO_SRNO}) => {
    const $widget = $(`#${WIDGET_USER_SRNO}`);
    $widget.attr("colabo_srno", COLABO_SRNO);

    const apiKey = WIDGET[$widget.attr('data-type')].API?.API_KEY;
    apiKey && deleteDatabase(`${apiKey}_${WIDGET_USER_SRNO}`)

    await DashboardApi.getApi('putProject', ({WIDGET_USER_SRNO, COLABO_SRNO}));
    projectList({WIDGET_USER_SRNO, COLABO_SRNO, WIDGET_SRNO: $widget.attr("srno")})
    globalValue.widgetInfo = ''
}

/*대시보드 배경 변경 함수*/
const setBackground = (bg, mode) => {
    $("#allMainContent").attr({
        bg,
        mode,
        'data-temp-bg': bg,
        'data-temp-mode': mode,
    });
}

/*채팅방 떠났을 경우 채팅방 아이템 제거 함수*/
const removeChatItem = ({CHATTING_ROOM_SRNO}) => {
    const $chatWidget = $('#chatting-' + CHATTING_ROOM_SRNO + "-widget");
    if ($chatWidget.length === 0) return;
    $chatWidget.remove();
    const $chat = $(".widget-chat > .chat-list");
    $chat.is(":empty") && $chat.append(getNoData('chat'));
}

/*웹뷰로 데이터 송신하는 함수*/
const BridgeSend = (info) => {
    if (agentInfo().isIphone) {
        window.webkit.messageHandlers.FLOW_WEB_BRIDGE.postMessage(info);
    } else if (agentInfo().isAndroid) {
        window.FLOW_WEB_BRIDGE.postMessage(info);
    } else {
        // alert(JSON.stringify(jsonData));
    }
}

/*필터값 변경 함수*/
const updateEndFilter = async (e, FIL_END_DT_GUBUN) => {
    const $target = $(e.target)
    const WIDGET_USER_SRNO = $target.closest('.js-filter-widget').attr('id');
    await DashboardApi.getApi('setFilter', ({
        USER_ID: _USER_ID,
        FIL_END_DT_GUBUN,
        WIDGET_USER_SRNO,
    }));
    globalValue.widgetInfo = "";
}

const saveSlogan = async (e) => {
    const $target = $(e.target).closest('.js-user-slogan')
    await DashboardApi.getApi('updatePrfl', ({
        SLGN: Mutil.tag2html($target.val())
    }));
}


export {
    putProject, BridgeSend, updateEndFilter,
    removeChatItem, clickPopupArea, setBackground, lnbAreaClick, sortableWidget, saveSlogan,
    isMobile
}
